import {Component, OnInit} from '@angular/core';
import {forkJoin, Observable} from 'rxjs';
import {PensionProductsPreviewService} from '../../pension/pension-products-preview.service';
import {publishReplay, refCount, switchMap, tap} from 'rxjs/operators';
import {AppConfigService, InsuranceCategoryFamily, Ticket, TicketType} from '@lifeislife/lifeislife-domain';
import {PendingTicketDraftService} from '../../service/pending-ticket-draft.service';
import {CustomerInsuranceInformationRequestHelperService} from '../../service/customer-insurance-information-request-helper.service';
import {ShellMessageService} from '../../service/shell-message-service';
import {ContactPensionProductsPreviewModel} from '../../pension/contact-pension-products-preview-model';
import {CustomerFrontAppSwitches} from '../../../domain/customer-front-app-switches';

@Component({
  selector: 'cf-pension-products-family-route',
  templateUrl: './pension-products-family-route.component.html',
  styleUrls: ['./pension-products-family-route.component.scss'],
})
export class PensionProductsFamilyRouteComponent implements OnInit {

  InsuranceCategoryFamily = InsuranceCategoryFamily;
  pensionProductsModel$: Observable<ContactPensionProductsPreviewModel[]>;
  pensionProductPerContactFeature$: Observable<boolean>;

  pensionModelLoading: boolean;

  pendingInsuranceInfoRequestDraft$: Observable<Ticket | null>;
  editingInsuranceInfoReaquestDraf$: Observable<Ticket | null>;


  constructor(
    private pensionProductModelService: PensionProductsPreviewService,
    private pendingTicketDraftService: PendingTicketDraftService,
    private shellMessageService: ShellMessageService,
    private configService: AppConfigService,
    private customerInsuranceInformationRequestHelperService: CustomerInsuranceInformationRequestHelperService) {
  }

  ngOnInit(): void {
    this.pendingInsuranceInfoRequestDraft$ = this.pendingTicketDraftService.getPendingDraft$(TicketType.CUSTOMER_INSURANCE_REQUEST);
    this.editingInsuranceInfoReaquestDraf$ = this.customerInsuranceInformationRequestHelperService.editingTicketDraft$;
    this.pensionProductPerContactFeature$ = this.configService.geTypedSwitchEnabled$<CustomerFrontAppSwitches>(
      CustomerFrontAppSwitches.pension_breackdown_per_contact, CustomerFrontAppSwitches,
    );

    this.pensionModelLoading = true;
    this.pensionProductsModel$ = this.pensionProductPerContactFeature$.pipe(
      switchMap((perContact) => this.pensionProductModelService.createPensionProductsPreviewModels$(perContact)),
      tap(a => this.pensionModelLoading = false),
      publishReplay(1), refCount(),
    );
  }


  onInfoRequestDraftCreateClick() {
    this.customerInsuranceInformationRequestHelperService.createDraft$(InsuranceCategoryFamily.RETIREMENT)
      .subscribe(d => {
        },
        e => this.shellMessageService.addError(`Impossible d'envoyer votre demande`, e));
  }

}
